<template>
  <!--
      	作者：gmshop
      	时间：2020-06-25
      	描述：设置-配送设置-配送
      -->
  <div class="product-add" v-loading="loading">
    <el-form size="small" ref="form" :model="form" label-width="150px">
        <div class="common-form">配送时间</div>

        <el-form-item label="配送日期: ">
            <el-input v-model="form.distribution_date" placeholder="请输入配送日期" type="number" style="width: 460px;">
              <template slot="append">天</template>
            </el-input>
            <div class="gray9">用户可选最远配送日期,默认7天</div>
        </el-form-item>
        <el-form-item label="送达间隔时间: ">
            <el-input v-model="form.interval_time" placeholder="请输入送达间隔时间" type="number" style="width: 460px;">
              <template slot="append">分钟</template>
            </el-input>
            <div class="gray9">用户下单时只能选择下单后多少分钟的时间为送达时间,默认30分钟</div>
        </el-form-item>
        <el-form-item label="配送时间：">
          <el-button size="small" class="el-icon-circle-plus" @click="AddPerformance(1)">添加</el-button>
          <table border="0" cellpadding="2" cellspacing="5" class="mt30">
            <tr>
              <th class="tl">起始时间</th>
              <th class="tl">结束时间</th>
              <th>操作</th>
            </tr>
            <tr v-for="(item, index) in form.distribution_time" :key="index">
              <td><el-time-picker v-model="item.start_time" format = 'HH:mm' value-format = 'HH:mm'
               :picker-options="{selectableRange: '00:00:00 - 23:59:59'}" placeholder="选择时间"></el-time-picker></td>
              <td><el-time-picker v-model="item.end_time" format = 'HH:mm' value-format = 'HH:mm'
               :picker-options="{selectableRange: '00:00:00 - 23:59:59'}" placeholder="选择时间"></el-time-picker></td>
              <td><el-button size="small" @click="delPerformance(index, 1)">删除</el-button></td>
            </tr>
          </table>
        </el-form-item>
        <div class="common-form">配送范围</div>

        <el-form-item label="配送类型: ">
          <el-radio-group v-model="form.distribution_type">
            <el-radio :label="0">按照公里数</el-radio>
            <el-radio :label="1">按区域</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="配送范围: " v-if="form.distribution_type == 0">
            <el-input v-model="form.distribution_area" placeholder="请输入配送范围" type="number" style="width: 460px;">
              <template slot="append">km</template>
            </el-input>
        </el-form-item>
        <el-form-item label="配送范围：" v-if="form.distribution_type == 1">
          <el-button size="small" class="el-icon-circle-plus" @click="AddPerformance(3)">添加</el-button>
          <table border="0" cellpadding="2" cellspacing="5" class="mt30">
            <tr>
              <th class="tl">配送区域</th>
              <th>操作</th>
            </tr>
            <tr v-for="(item, index) in form.distribution_area_list" :key="index">
              <td>
                <el-select v-model="item.province_id" placeholder="省" @change="initCity(index)">
                  <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList" :key='index1'></el-option>
                </el-select>
                <el-select v-if="item.province_id!=''" v-model="item.city_id" placeholder="市" @change="initRegion(index)">
                  <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[item.province_id]['city']"
                    :key='index2'></el-option>
                </el-select>
                <el-select v-if="item.city_id!=''" v-model="item.region_id" placeholder="区">
                  <el-option :label="item3.name" :value="item3.id" v-for="(item3,index3) in areaList[item.province_id]['city'][item.city_id]['region']"
                    :key='index3'></el-option>
                </el-select>
              </td>
              <td><el-button size="small" @click="delPerformance(index, 3)">删除</el-button></td>
            </tr>
          </table>
        </el-form-item>
        <el-form-item label="配送费类型：">
          <el-radio-group v-model="form.distribution_cost_type">
            <el-radio :label="0">固定比例</el-radio>
            <el-radio :label="1">固定金额</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="配送费: " v-if="form.distribution_cost_type == 0">
            <el-input v-model="form.distribution_cost" placeholder="请输入配送费" type="number" style="width: 460px;">
              <template slot="append">元/km</template>
            </el-input>
        </el-form-item>
        <el-form-item label="配送费：" v-if="form.distribution_cost_type == 1">
          <el-button size="small" class="el-icon-circle-plus" @click="AddPerformance(2)">添加</el-button>
          <table border="0" cellpadding="2" cellspacing="5" class="mt30">
            <tr>
              <th class="tl">距离门槛（km）</th>
              <th class="tl">配送费（元）</th>
              <th>操作</th>
            </tr>
            <tr v-for="(item, index) in form.distribution_cost_list" :key="index">
              <td><el-input size="small" v-model="item.distance"  type="number" placeholder="请输入距离门槛"></el-input></td>
              <td><el-input size="small" v-model="item.cost"  type="number" placeholder="请输入配送费"></el-input></td>
              <td><el-button size="small" @click="delPerformance(index, 2)">删除</el-button></td>
            </tr>
          </table>
        </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
         <el-button type="primary" @click="onSubmit" :loading="loading">保存</el-button>
      </div>
    </el-form>

  </div>
</template>
<script>
  import SettingApi from '@/api/setting.js';
  export default {
    data() {
      return {
        form: {
          is_distribution: false,
          distribution_date:7,
          interval_time:2,
          distribution_time: [],
          distribution_area:0,
          distribution_area_list:[],
          distribution_cost_type:0,
          distribution_cost:0,
          distribution_cost_list:[],

        },
        /*是否正在加载*/
        loading: true,
        /*省市区*/
        areaList: [],
      };
    },
    created() {
      /*获取列表*/
      this.getSetting();
    },
    methods: {
      /*获取设置*/
      getSetting() {
        let self = this;
        let Params = {};
        SettingApi.getDistributionSetting(Params, true)
          .then(data => {
            self.form = data.data.distribution;
            self.areaList = data.data.regionData;
            self.loading = false;
          })
          .catch(error => {});
      },

      /*初始化城市id*/
      initCity(index) {
        this.form.distribution_area_list[index].city_id = ''
      },
      /*初始化区id*/
      initRegion(index) {
        this.form.distribution_area_list[index].region_id = ''
      },

      AddPerformance(e){
        let self = this;
        if (e == 1) {
          let data = {'start_time':0,'end_time':0};
          self.form.distribution_time.push(data);
        }
        if (e == 2) {
          let data = {'distance':0,'cost':0};
          self.form.distribution_cost_list.push(data);
        }
        if (e == 3) {
          let data = {'province_id':'', 'city_id':'', 'region_id':''};
          self.form.distribution_area_list.push(data);
        }
      },
      delPerformance(key, e){
        let self = this;
        let newdata = [];
        if (e == 1) {
          self.form.distribution_time.forEach((item,index)=>{
            if(index != key){
              newdata.push(item);
            }
          });
          self.form.distribution_time = newdata;
        }
        if (e == 2) {
          self.form.distribution_cost_list.forEach((item,index)=>{
            if(index != key){
              newdata.push(item);
            }
          });
          self.form.distribution_cost_list = newdata;
        }
        if (e == 3) {
          self.form.distribution_area_list.forEach((item,index)=>{
            if(index != key){
              newdata.push(item);
            }
          });
          self.form.distribution_area_list = newdata;
        }

      },
      /*点击保存*/
      onSubmit() {
        let self = this;
        let params = self.form;
        self.loading = true;
        SettingApi.editDistributionSetting(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，保存成功',
                type: 'success'
              });
              self.getSetting();
            } else {
              self.loading = false;
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/setting/distribution/dialog/distribution.vue